
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import HttpFunction from "../components/utils/HttpFunction";

// Stateの初期状態
const initialState = {
    organizer: {
        organizer_id: "",
        email_address: "",
        business_name: "",
        business_account: "",
        login_token: "",
        // yahoo_token: "",
        user_login: process.env.MIX_USER_TOKEN ? true : false,
        error_message: "",
    },
};

const localStorage_organizer = "organizer";

//ログイントークンから幹事取得
export const UserInfoGet = createAsyncThunk(
    "Information/UserInfoGet",
    async (arg, thunkAPI) => {
        try {
            if(arg === null)
            {
                //パラメータ無しの場合、localStorageに保存したログイントークンから取得
                const login_token = getLocalStorage(localStorage_organizer);
                if(login_token)
                {
                    arg = {login_token: login_token};
                }
            }
            const data = await HttpFunction(
                "GET",
                "/api/GetUserByToken",
                arg,
                //api_key
            );
            // for (let key in data) {
            //     console.log(key);
            // }
            let stateActions = null;

            if (data.length !== 0) {
                if (data.error_message) {
                    stateActions = {
                        error_message: data.error_message,
                    };
                } else {
                    if(data.organizer.organizer_id)
                    {
                        stateActions = {
                            organizer_id: data.organizer.organizer_id,
                            email_address: data.organizer.email_address,
                            business_name: data.organizer.business_name,
                            business_account: data.organizer.business_account,
                            login_token: data.organizer.login_token,
                            // yahoo_token: data.organizer.yahoo_token,
                            user_login: true,
                            error_message: "",
                        };
                    }
                    else
                    {
                        //トークンに該当するユーザーはログインしていないため、ログイン情報を削除
                        localStorage.removeItem(localStorage_organizer);
                        stateActions = {
                            login_token: "",
                            user_login: false,
                            error_message: "",
                        };
                    }
                }
            }

            return { data: stateActions };
        } catch (err) {
            // console.log("err:" + err);
            const error = {
                error_message: err.toString(),
            };
            return { data: error };
        }
    }
);

//localStorageに保存したログイントークンを取得
export function getLocalStorage(id) {
    const value = localStorage.getItem(id);
    if (value !== null) {
        return value;
    }
    return "";
};

//localStorageにログイントークンを保存
export function saveLocalStorage(state, id)
{
    if(state)
    {
        localStorage.setItem(id, state);
    }
};

// Sliceを生成する
const slice = createSlice({
    name: "Information",
    initialState,
    reducers: {
        set_value: (state, action) => {
            const name = action.payload[0];
            const value = action.payload[1];
            const type = action.payload[2];

            if (type) {
                state[name] = value;
                let new_type = state[type];
                new_type[name] = value;
                state[type] = new_type;
            } else {
                state[name] = value;
            }
        },
        logout: (state, action) => {
            const name = action.payload[0];
            state[name] = initialState[name];
            localStorage.removeItem(name);
        },
    },
    extraReducers: {
        [UserInfoGet.fulfilled]: (state, action) => {
            for (let key in action.payload.data) {
                state.organizer[key] = action.payload.data[key];
            }
            //ログイントークン保存
            if(action.payload.data["login_token"] !== null)
            {
                saveLocalStorage(action.payload.data["login_token"], localStorage_organizer);
            }
            else
            {
                localStorage.removeItem(localStorage_organizer);
            }
        },
        [UserInfoGet.rejected]: (state, action) => {
            // console.log("rejected:ネットワークエラー");
            state.organizer.error_message = "ネットワークエラー";
            // console.log("state.organizer.error_message:" + state.organizer.error_message);
        },
    },
});

// Reducerをエクスポートする
export default slice.reducer;

// Action Creatorsをエクスポートする
export const { set_value, logout } = slice.actions;
